import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import LoadMask from "Utils/LoadMask/LoadMask";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { tableOptions, BreakLine } from "Utils/tableOptions";
import { icons } from "icons";
import { formatoNombre } from "Utils/CamposComunes";
import { RenderMoneda, RenderNumero } from "Utils/renderField/renderTableField";
import { opcionesDevolucion, opcionesReingreso } from "utility/variables";
import ModalAyuda from "Utils/Ayuda";
import NumberFormat from "react-number-format";

class Motivos extends Component {
    static propTypes = {
        factura: PropTypes.object.isRequired,
        loader: PropTypes.bool.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            modalAyuda: false,
            itemsDevolucion: [
                {
                    src: icons.devolucion_p7,
                    alt: "Paso 1",
                },
                {
                    src: icons.devolucion_p8,
                    alt: "Paso 2",
                },
                {
                    src: icons.devolucion_p9,
                    alt: "Paso 3",
                },
                {
                    src: icons.devolucion_p10,
                    alt: "Paso 4",
                },
            ],
        };
    }

    componentWillMount() {}
    closeModalAyuda = () => {
        this.setState({ modalAyuda: false });
    };
    openModalAyuda = () => {
        this.setState({ modalAyuda: true });
    };

    render() {
        const {
            elegidos: productos,
            loader,
            factura,
            total,
            adicionales_seleccionados,
        } = this.props;
        const { modalAyuda, itemsDevolucion } = this.state;

        const movimiento = factura.movimiento;
        const cuenta_cobrar = movimiento ? movimiento.cuenta_cobrarpagar : null;

        const options = _.cloneDeep(tableOptions);
        options.noDataText = loader ? "Cargando..." : options.noDataText;
        if (productos.length === 0) {
            return (
                <Redirect
                    to={`/devolucion/seleccion_de_producto/${this.props.match.params.id}`}
                />
            );
        }
        let mostrar_alertas = false;
        if (cuenta_cobrar) {
            if (cuenta_cobrar.saldo < total) mostrar_alertas = true;
        }
        if (factura) {
            if (factura.movimiento.total_cobrar_pagar < total)
                mostrar_alertas = true;
        }

        return (
            <React.Fragment>
                <div className="col-12">
                    <LoadMask loading={loader} blur light>
                        <div className="d-flex flex-column grid-container p-1 p-sm-3">
                            <div
                                style={{
                                    position: "absolute",
                                    top: "15px",
                                    right: "15px",
                                }}
                            >
                                <button
                                    className="btn btn-ayuda fnt-16 d-flex align-items-center justify-content-center"
                                    style={{ width: "2rem", height: "2rem" }}
                                    onClick={this.openModalAyuda}
                                >
                                    <img
                                        src={icons.ayuda}
                                        alt="ayuda"
                                        title="Ayuda"
                                        style={{
                                            margin: "0",
                                            height: "1.1rem",
                                        }}
                                    />
                                </button>
                            </div>

                            {/* region ENCABEZADO */}
                            <div className="d-flex flex-column flex-sm-row justify-content-between">
                                <div className="d-flex flex-column">
                                    <h5 className="font-weight-bold">
                                        Código de venta
                                    </h5>
                                    <div className="verde-oscuro">
                                        <h3>{factura.codigo}</h3>
                                    </div>
                                </div>
                                <div className="d-flex flex-column">
                                    <h5 className="font-weight-bold">
                                        Cliente
                                    </h5>
                                    <div className="verde-oscuro">
                                        {factura.cliente.nombre}
                                    </div>
                                </div>
                                <div className="d-flex flex-column">
                                    <h5 className="font-weight-bold">Nit</h5>
                                    <div className="verde-oscuro">
                                        {factura.cliente.nit
                                            ? factura.cliente.nit
                                            : "Consumidor Final"}
                                    </div>
                                </div>
                                <div className="d-flex flex-column mr-5">
                                    <h5 className="font-weight-bold">
                                        Total Venta
                                    </h5>
                                    <div className="verde-oscuro text-right">
                                        <RenderMoneda
                                            monto={
                                                factura
                                                    ? factura.movimiento
                                                          .total_cobrar_pagar
                                                    : 0
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            {/* endregion ENCABEZADO */}
                            {/* region SELECCION DE PRODUCTOS A DEVOLVER */}
                            <div className="mt-2 mb-2">
                                Selecciona los motivos por el cual serán
                                devueltos
                            </div>
                            <BootstrapTable
                                data={loader ? [] : productos}
                                remote
                                hover
                                tdStyle={BreakLine}
                                thStyle={BreakLine}
                                options={options}
                            >
                                <TableHeaderColumn
                                    tdStyle={BreakLine}
                                    thStyle={BreakLine}
                                    dataField="nombre"
                                    dataFormat={formatoNombre}
                                >
                                    Nombre
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    dataAlign="right"
                                    dataField="precio"
                                    width="15%"
                                    tdStyle={BreakLine}
                                    thStyle={BreakLine}
                                    dataFormat={(cell) => {
                                        return <RenderMoneda monto={cell} />;
                                    }}
                                >
                                    Precio
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    dataField=""
                                    width="100px"
                                    dataAlign="right"
                                    dataField="porcentaje_precio"
                                    dataFormat={(cell, row) => {
                                        return (
                                            <NumberFormat
                                                className="form-control text-right"
                                                placeholder="100 %"
                                                decimalScale={2}
                                                fixedDecimalScale={false}
                                                value={cell}
                                                suffix={" %"}
                                                onValueChange={(values) => {
                                                    this.props.setParamElegido(
                                                        "porcentaje_precio",
                                                        values.floatValue
                                                            ? values.floatValue
                                                            : 0,
                                                        row
                                                    );
                                                }}
                                            />
                                        );
                                    }}
                                >
                                    % Precio
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    dataAlign="right"
                                    dataField="precio_calculado"
                                    width="100px"
                                    tdStyle={BreakLine}
                                    thStyle={BreakLine}
                                    dataFormat={(cell, row) => {
                                        return (
                                            <RenderMoneda
                                                monto={cell ? cell : row.precio}
                                            />
                                        );
                                    }}
                                >
                                    Precio real
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    dataAlign="right"
                                    dataField="cantidad"
                                    width="100px"
                                    tdStyle={BreakLine}
                                    thStyle={BreakLine}
                                    dataFormat={(cell, row) => {
                                        return (
                                            <RenderNumero
                                                monto={cell ? cell : row.precio}
                                                decimalScale={
                                                    row.producto.a_granel
                                                        ? 3
                                                        : 2
                                                }
                                            />
                                        );
                                    }}
                                >
                                    Cantidad
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    dataField="key"
                                    isKey
                                    dataFormat={(cell, row) => {
                                        return (
                                            <select
                                                className={"form-control"}
                                                onChange={(e) => {
                                                    this.props.setParamElegido(
                                                        "motivo",
                                                        e.target.value,
                                                        row
                                                    );
                                                }}
                                                value={row.motivo}
                                            >
                                                {opcionesDevolucion.map(
                                                    (opcion) => {
                                                        return (
                                                            <option
                                                                key={
                                                                    opcion.value
                                                                }
                                                                value={
                                                                    opcion.value
                                                                }
                                                            >
                                                                {opcion.label}
                                                            </option>
                                                        );
                                                    }
                                                )}
                                            </select>
                                        );
                                    }}
                                >
                                    Motivo
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    dataField=""
                                    dataFormat={(cell, row) => {
                                        return (
                                            <input
                                                type="text"
                                                className="form-control"
                                                ref={(node) => {
                                                    this.nota = node;
                                                    if (
                                                        this.nota &&
                                                        row.nota !== undefined
                                                    ) {
                                                        this.nota.value =
                                                            row.nota;
                                                    }
                                                }}
                                                onChange={(e) => {
                                                    if (this.nota) {
                                                        this.props.setParamElegido(
                                                            "nota",
                                                            e.target.value,
                                                            row
                                                        );
                                                    }
                                                }}
                                            />
                                        );
                                    }}
                                >
                                    Nota
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    dataField=""
                                    tdStyle={BreakLine}
                                    thStyle={BreakLine}
                                    dataFormat={(cell, row) => {
                                        return (
                                            <select
                                                className={"form-control"}
                                                onChange={(e) => {
                                                    this.props.setParamElegido(
                                                        "ingreso_bodega",
                                                        e.target.value ==
                                                            "true",
                                                        row
                                                    );
                                                }}
                                                value={row.ingreso_bodega}
                                            >
                                                {opcionesReingreso.map(
                                                    (opcion) => {
                                                        return (
                                                            <option
                                                                key={
                                                                    opcion.value
                                                                }
                                                                value={
                                                                    opcion.value
                                                                }
                                                            >
                                                                {opcion.label}
                                                            </option>
                                                        );
                                                    }
                                                )}
                                            </select>
                                        );
                                    }}
                                >
                                    ¿Va a regresar a bodega?
                                </TableHeaderColumn>
                            </BootstrapTable>
                            {/* endregion SELECCION DE PRODUCTOS A DEVOLVER */}
                            <br />
                            <div className="d-flex justify-content-between flex-row ">
                                {mostrar_alertas && (
                                    <div className="flex1 d-flex flex-column text-warning">
                                        {cuenta_cobrar &&
                                            cuenta_cobrar.saldo < total && (
                                                <h5>
                                                    <i className="fa fa-warning mr-3"></i>
                                                    El total es mayor al saldo
                                                    disponible del cliente (
                                                    <RenderMoneda
                                                        monto={
                                                            cuenta_cobrar.saldo
                                                        }
                                                    />
                                                    )
                                                </h5>
                                            )}
                                        {factura &&
                                            factura.movimiento
                                                .total_cobrar_pagar < total && (
                                                <h5>
                                                    <i className="fa fa-warning mr-3"></i>
                                                    El total es mayor al total
                                                    de la venta
                                                </h5>
                                            )}
                                    </div>
                                )}
                                <div
                                    className={`${
                                        mostrar_alertas
                                            ? ""
                                            : "w-100 text-right"
                                    }`}
                                >
                                    {adicionales_seleccionados.map(
                                        (adicional, index) => {
                                            return (
                                                <h6
                                                    className={`${
                                                        index + 1 !=
                                                        adicionales_seleccionados.length
                                                            ? "mb-0"
                                                            : ""
                                                    }`}
                                                    key={index}
                                                >
                                                    {adicional.nombre}:
                                                    <RenderMoneda
                                                        className="ml-2"
                                                        monto={adicional.precio}
                                                    />
                                                </h6>
                                            );
                                        }
                                    )}
                                    <h5>
                                        Total:
                                        <RenderMoneda
                                            className="ml-2"
                                            monto={total}
                                        />
                                    </h5>
                                </div>
                            </div>
                            <br />
                            <div className="d-flex justify-content-center flex-row">
                                <Link
                                    to={`/devolucion/seleccion_de_producto/${this.props.match.params.id}`}
                                    className="btn btn-tertiary m-1 align-self-center"
                                >
                                    <em className="fa fa-arrow-left" /> Atrás
                                </Link>
                                <Link
                                    className="btn btn-primary m-1 align-self-center"
                                    to={`/devolucion/seleccion_de_producto/${this.props.match.params.id}/motivos/vale`}
                                >
                                    <i className="fa fa-check" />
                                    &nbsp;Siguiente
                                </Link>
                            </div>
                        </div>
                    </LoadMask>
                    <ModalAyuda
                        open={modalAyuda}
                        closeModal={this.closeModalAyuda}
                        openModal={this.openModalAyuda}
                        items={itemsDevolucion}
                    />
                </div>
            </React.Fragment>
        );
    }
}

export default Motivos;
